(function () {
var $13133e7513a8df00$var$selectors = {
    container: '.group-cuddle',
    item: '.group-cuddle__item'
};
var $13133e7513a8df00$var$classNames = {
    active: 'group-cuddle__item--active'
};
document.querySelectorAll($13133e7513a8df00$var$selectors.container).forEach(function(group) {
    var items = group.querySelectorAll($13133e7513a8df00$var$selectors.item);
    var handleItem = function(e) {
        var item = e.currentTarget;
        var itemIsActive = item.classList.contains($13133e7513a8df00$var$classNames.active);
        items.forEach(function(item) {
            return item.classList.remove($13133e7513a8df00$var$classNames.active);
        });
        if (!itemIsActive) item.classList.add($13133e7513a8df00$var$classNames.active);
    };
    items.forEach(function(item) {
        item.addEventListener('click', handleItem);
    });
});

})();
//# sourceMappingURL=group_cuddle.min.js.map
